import React from 'react';

const ComingSoonPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/coming-soon',
			exact: true,
			component: React.lazy(() => import('./ComingSoonPage')),
		},
	],
};

export default ComingSoonPageConfig;
